module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/passenger-manual-notif/passenger-manual-notif-datatable/passenger-manual-notif-datatable.component.css
// module id = ./src/app/components/passenger-manual-notif/passenger-manual-notif-datatable/passenger-manual-notif-datatable.component.css
// module chunks = main